
import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { Row, Col } from "react-bootstrap";
import ModelLoading from "../../utils/ModelLoading";
import { SHARED_ICONS } from "../../theme";
import Button from '@mui/material/Button';
import UploadFromDisk from './uploadFromDisk';
import { UploadFromWebcam } from "./UploadFromWebcam";
import { _rest } from '../../services/api';
import { Notification } from "../../services/api";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { IMGS } from "../../theme";
import INSTRUCTIONS from "./instructions";
import useWindowDimensions from "../../hooks/useWindowDimensions";

import {
   isFaceDetectionModelLoaded,
   isFacialLandmarkDetectionModelLoaded,
   isFeatureExtractionModelLoaded,
   loadModels,
} from "../../faceUtil";

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default ({ newFacePhoto, user, logout }) => {
   const [isAllModelLoaded, setIsAllModelLoaded] = useState(false);
   const [loadingMessage, setLoadingMessage] = useState("");
   const [loadingMessageError, setLoadingMessageError] = useState("");
   const [isSubmitting, setIsSubmitting] = React.useState(false);
   const { height, width } = useWindowDimensions();

   const [open, setOpen] = React.useState({ diskOptOpen: false, cameraOptOpen: false, InstructionGalleryOpen: false, InstrcutionCameraOpen: false });

   const handleGalleryPopup = (status) => {
      setOpen((prevOpen) => ({ ...prevOpen, diskOptOpen: status }));
   };

   const handleInstructionGalleryPopup = (status) => {
      setOpen((prevOpen) => ({ ...prevOpen, InstructionGalleryOpen: status }));
   };

   const handleCameraPopup = (status) => {
      setOpen((prevOpen) => ({ ...prevOpen, cameraOptOpen: status }));
   };

   const handleInstructionCameraPopup = (status) => {
      setOpen((prevOpen) => ({ ...prevOpen, InstrcutionCameraOpen: status }));
   };


   const closeWebCam = () => { handleCameraPopup(false) }


   const addFacePhotoCallback = async (data) => {
      setIsSubmitting(true);
      try {
         const res = await _rest.saveUserFaceImage(data, user.user_id);
         if (res?.success) {
            newFacePhoto(res?.data)
            Notification('Face Uploaded', '', 'success')
         }
      } catch (error) {
         if (error.status === 401)
            logout();
      }
      setIsSubmitting(false); handleGalleryPopup(false)
   };



   useEffect(() => {
      async function loadingTheModel() {
         await loadModels(setLoadingMessage, setLoadingMessageError);
         setIsAllModelLoaded(true);
      }
      if (
         !!isFaceDetectionModelLoaded() &&
         !!isFacialLandmarkDetectionModelLoaded() &&
         !!isFeatureExtractionModelLoaded()) {
         setIsAllModelLoaded(true);
         return;
      }
      loadingTheModel();
   }, [isAllModelLoaded]);




   return (
      <>
         {!isAllModelLoaded ? (
            <>
               <ModelLoading loadingMessage={loadingMessage} />
            </>
         ) : loadingMessageError ? (
            <div className="error">{loadingMessageError}</div>
         ) : (
            isAllModelLoaded &&
            loadingMessageError.length === 0 && (
               <>
                  <div id="upload-btn-grp">
                     <h6>Upload new face using:
                        <Button variant="contained" startIcon={SHARED_ICONS.CollectionsIcon} onClick={() => handleInstructionGalleryPopup(true)} disabled={isSubmitting}>
                           Gallery
                        </Button>
                        <Button variant="contained" startIcon={SHARED_ICONS.CameraAltIcon} onClick={() => handleInstructionCameraPopup(true)} disabled={isSubmitting}>
                           Camera
                        </Button>
                     </h6>
                  </div>
               </>))}

         {/* Gallery instructions */}
         <Dialog
            open={open.InstructionGalleryOpen}
            fullWidth
            maxWidth={'sm'}
            className={'gallery-face-instruction-modal'}
         >
            <DialogTitle id="alert-dialog-title">
               Instructions!
               <IconButton onClick={() => handleInstructionGalleryPopup(false)} className="close-icon-btn">
                  <CloseIcon />
               </IconButton>
            </DialogTitle>

            <DialogContent className="px-0">
               <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
                  <img src={IMGS.instructions} />
               </div>
               {INSTRUCTIONS?.gallery?.map((item, i) => (
                  <Row key={i}>
                     <Col xs={1} className="m-auto p-0 text-end"><p className="instruction-p">{i + 1}. </p></Col>
                     <Col xs={11}><p className="instruction-p">{item}.</p></Col>
                  </Row>
               ))}
               <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0 12px' }}>
                  <Button variant="contained" className="btn-submit"
                     onClick={() => { handleGalleryPopup(true); handleInstructionGalleryPopup(false); }}
                     size="small" >
                     Continue
                  </Button>
               </div>
            </DialogContent>
         </Dialog>


         {/* Gallery Modal */}
         <Dialog
            open={open.diskOptOpen}
            fullWidth
            maxWidth={'sm'}
            className={'upload-face-from-disk-modal'}
            onClose={() => handleGalleryPopup(false)}
         >
            <DialogTitle id="alert-dialog-title">
               {"Select a clear picture of yours only"}
               <IconButton onClick={() => handleGalleryPopup(false)} className="close-icon-btn">
                  <CloseIcon />
               </IconButton>
            </DialogTitle>
            <DialogContent>
               <UploadFromDisk
                  addFacePhotoCallback={addFacePhotoCallback}
                  isSubmitting={isSubmitting}
               />
            </DialogContent>
         </Dialog>



         {/* Webcam instructions */}
         <Dialog
            open={open.InstrcutionCameraOpen}
            fullWidth
            maxWidth={'sm'}
            className={'webcam-face-instruction-modal'}
         >
            <DialogTitle id="alert-dialog-title">
               Instructions!
               <IconButton onClick={() => handleInstructionCameraPopup(false)} className="close-icon-btn">
                  <CloseIcon />
               </IconButton>
            </DialogTitle>

            <DialogContent className="px-0">
               <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
                  <img src={IMGS.instructions} />
               </div>
               {INSTRUCTIONS?.webcam?.map((item, i) => (
                  <Row key={i}>
                     <Col xs={1} className="m-auto p-0 text-end"><p className="instruction-p">{i + 1}. </p></Col>
                     <Col xs={11}><p className="instruction-p">{item}.</p></Col>
                  </Row>
               ))}
               <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0 12px' }}>
                  <Button variant="contained" className="btn-submit"
                     onClick={() => { handleCameraPopup(true); handleInstructionCameraPopup(false) }}
                     size="small" >
                     Continue
                  </Button>
               </div>
            </DialogContent>


         </Dialog>

         {/* Webcam Modal */}
         <Modal
            open={open.cameraOptOpen}
            footer={null}
            onCancel={() => handleCameraPopup(false)}
            style={{ top: 0 }}
            width={width <= 640 ? width : 640}
            closable={true}
            destroyOnClose
            className="webcam-popup"
         >
            <UploadFromWebcam
               addFacePhotoCallback={addFacePhotoCallback}
               isSubmitting={isSubmitting}
               closeWebCam={closeWebCam}
            />
         </Modal>
      </>
   );
};
